var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8527 13.6458C22.0484 13.8407 22.0489 14.1573 21.854 14.3529L16.389 19.8374C16.1741 20.0531 15.8248 20.0531 15.6098 19.8374L10.1448 14.3529C9.94993 14.1573 9.95049 13.8407 10.1461 13.6458C10.3417 13.4509 10.6583 13.4515 10.8532 13.6471L15.9994 18.8117L21.1456 13.6471C21.3406 13.4515 21.6571 13.4509 21.8527 13.6458Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.1616c47e39beef5e52d205795a218929.svg";
export { ForwardRef as ReactComponent };